import { type Kudo, createKudoInContentObject } from '../../kudo';
import type {
  KudoContentObjectDetailDataObject,
  KudoContentObjectListDataObject,
  PublicKudoContentObjectDataObject,
} from '../../service';
import {
  type CommunityContentObjectDetail,
  type CommunityContentObjectList,
  type PublicCommunityContentObject,
  createCommunityContentObjectDetail,
  createCommunityContentObjectList,
  createPublicCommunityContentObject,
} from '../contentable-type-content-objects';

export type CommunityKudoContentObjectDetail = {
  kudo: Kudo;
  type: 'kudo';
} & CommunityContentObjectDetail;

export type CommunityKudoContentObjectList = {
  kudo: Kudo;
  type: 'kudo';
} & CommunityContentObjectList;

export type KudoContentObjectDetail = CommunityKudoContentObjectDetail;

export type KudoContentObjectList = CommunityKudoContentObjectList;

export const createKudoContentObjectDetail = (data: KudoContentObjectDetailDataObject): KudoContentObjectDetail => ({
  ...createCommunityContentObjectDetail(data),
  kudo: createKudoInContentObject(data.kudo),
  type: 'kudo',
});

export const createKudoContentObjectList = (data: KudoContentObjectListDataObject): KudoContentObjectList => ({
  ...createCommunityContentObjectList(data),
  kudo: createKudoInContentObject(data.kudo),
  type: 'kudo',
});

export type PublicCommunityKudoContentObject = {
  kudo: Kudo;
  type: 'kudo';
} & PublicCommunityContentObject;

export type PublicKudoContentObject = PublicCommunityKudoContentObject;

export const createPublicKudoContentObject = (data: PublicKudoContentObjectDataObject): PublicKudoContentObject => ({
  ...createPublicCommunityContentObject(data),
  kudo: createKudoInContentObject(data.kudo),
  type: 'kudo',
});
